<div
  class="checkbox checkbox--agent"
  [ngClass]="{ 'checkbox--disabled': disabled }"
>
  <input
    class="checkbox__control"
    type="checkbox"
    [id]="name"
    [name]="name"
    [disabled]="disabled"
    [(ngModel)]="value"
  />
  <label
    class="checkbox__label"
    [for]="name"
  ><span [innerHTML]="label"></span></label>
</div>
